
<mat-form-field class="no-underline" appearance="legacy" [style.width.px]="cellWidth">
  <mat-select [(ngModel)]="selectedValues" multiple [compareWith]="compareItems" (openedChange)="onOpenedChange($event)">
    <mat-option *ngFor="let option of options" [value]="option">{{ option.StandTitle }}
    </mat-option>
  </mat-select>    
  </mat-form-field>


